import { Pill } from '@/components/shared/components/Pill';
import styled from '@emotion/styled';
import { H4, rem } from '@triumph/design-system';

import { DDDCard, DDDTable, DDDTableValue } from '../../Applicant.StyledComponents';

// A shrink-wrapped pill is a different width per status, leaving the sentences beside them ragged
// down the page. Sized in ch rather than px so the longest label, "Not Applicable", cannot clip.
export const StatusPill = styled(Pill)`
    min-width: 15ch;
    justify-content: center;
    flex-shrink: 0;
    white-space: nowrap;
`;

// Separate tables per group, so only a shared width and fixed geometry line the columns up.
export const GroupTableWrapper = styled.div`
    width: 100%;
`;

export const GroupTable = styled(DDDTable)`
    table-layout: fixed;
    font-size: ${rem(13.5)};

    & th:nth-of-type(1) {
        width: 30%;
    }

    & th:nth-of-type(2) {
        width: 42%;
    }

    & th:nth-of-type(3) {
        width: 28%;
    }
`;

// The shared DDD cell top-aligns to line values up with their key; here the three cells are peers,
// so a wrapped status sentence would leave the vendor and timing hanging at the top.
export const VendorStatusCell = styled(DDDTableValue)`
    vertical-align: middle;
    color: #1e293b;
`;

export const VendorStatusRowItem = styled.tr`
    &:nth-of-type(even) {
        background-color: ${({ theme }) => theme.colors.greyscale.gray2_5};
    }
`;

// The shared DDD key cell is a right-aligned label for a key/value pair, so it cannot double as a
// column title.
export const VendorStatusHeaderCell = styled.th`
    text-align: left;
    padding: ${rem(6)} ${rem(8)};
    font-size: ${rem(12)};
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: ${rem(0.65)};
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
`;

// Keeps the width the status tables had before they moved into a card.
export const VendorStatusCard = styled(DDDCard)`
    max-width: 75vw;
`;

export const VendorStatusWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
    margin-bottom: ${rem(24)};
`;

export const VendorStatusDivider = styled.hr`
    border: none;
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.greyscale.gray15};
    margin: ${rem(8)} 0 0;
`;

export const VendorStatusGroupBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(4)};
    padding: ${rem(8)} ${rem(20)} ${rem(12)};
`;

export const StatusCell = styled.div`
    display: flex;
    align-items: center;
    gap: ${rem(8)};
`;

// Indented and spaced as a set so each owner reads as a division of the group above it, not a group of its own.
export const OwnerSubgroups = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(16)};
`;

export const OwnerSubgroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(4)};
`;

export const OwnerTitle = styled(H4)`
    margin: 0;
    color: #1e293b;
    font-size: ${rem(13.5)};
    font-weight: 600;
`;

// Beside the status sentence rather than in a fourth column, so the three column widths stay as they are.
export const ViewDddLink = styled.a`
    color: ${({ theme }) => theme.colors.primary.actionDefault};
    text-decoration: underline;
    white-space: nowrap;
    flex-shrink: 0;
`;

export const GroupReason = styled.p`
    margin: 0;
    font-size: ${rem(12)};
    color: #64748b;
`;
